import moment from 'moment';
import React, { useEffect, useState } from "react";

import causalService from "../services/causal.service";
import personaService from "../services/persona.service";
import reclutamientoService from "../services/reclutamiento.service";

import { useConfirm } from "material-ui-confirm";
import { Oval } from 'react-loader-spinner';

/** Material UI */
import { Divider, TextField } from "@mui/material";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { Container } from "@mui/system";
import MUIDataTable from 'mui-datatables';
import { SnackbarProvider, useSnackbar } from 'notistack';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

const Admin = () => {
    const [casuales, setCausales] = useState([]);
    const [loading, setLoading] = useState(false);
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const [arr_sel, SetArrSel] = useState([]);
    const [personas, setPersonas] = useState([]);
    const [open, setOpen] = useState(false);
    const [motivobloqueo, setMotivoBloqueo] = useState('');
    const [rut, setRut] = useState('');

    useEffect(() => {
        retreiveCasuales();
    }, []);

    function retreivePersonas() {
        setLoading(true);
        reclutamientoService.getAll()
            .then(resp => {
                console.log(resp.data);
                setPersonas(resp.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }

    function retreiveCasuales() {
        console.log(loading);
        setLoading(true);
        causalService.getAll()
            .then(async resp => {
                const arr = resp.data.filter(v=>v.estado !== "anulado");
                arr.sort(function (a, b) {
                    return new Date(b.createdAt) - new Date(a.createdAt)
                });
                var arr_ = [];
                for (var i in arr) {
                    //var n = await getPersona(arr[i].personaId);
                    const data = {
                        id: arr[i].id,
                        nombre: arr[i].persona ? arr[i].persona.perNombre1 + " " + arr[i].persona.perApPaterno + " " + arr[i].persona.perApMaterno : "",
                        descripcion: arr[i].descripcion,
                        evaluacion: arr[i].evaluacion,
                        estado_desv: arr[i].persona ? arr[i].persona.estado_desv : "",
                        estado_bloqueo: arr[i].persona ? arr[i].persona.estado_bloqueo : "",
                        rut: arr[i].persona ? arr[i].persona.Rut : "",//n.Rut
                        motivo_bloqueo: arr[i].persona ? arr[i].persona.motivo_bloqueo : "",
                        unidad: arr[i].persona ? arr[i].persona.ctoDescripcion : "",
                        cargo: arr[i].persona ? arr[i].persona.recDescripcion : "",
                        fecha_ingreso: moment(arr[i].fecha_ingreso).format("DD-MM-YYYY")
                    }
                    arr_.push(data);
                }
                setCausales(arr_);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }

    async function getPersona(id) {
        let persona = await personaService.getById(id);
        return persona.data;
    }

    const handleClose = () => setOpen(false);

    const bloquear = (rut) => {
        setLoading(true);
        confirm({ description: '¿Está seguro de bloquear al trabajador?', title: 'Bloquear a trabajador', confirmationText: 'Aceptar', cancellationText: 'Cancelar' })
            .then(async () => {
                setRut(rut);
                setOpen(true);
                setLoading(false);
                /* let p = await personaService.getPorRut(rut);
                console.log("Bloquer a usuario");
                reclutamientoService.getUsuarioPorRut(rut)
                    .then(resp => {
                        if (resp.data.length !== 0) {
                            //Si existe la persona, actualizamos el estado a bloqueado
                            console.log(resp);
                            reclutamientoService.updateTrabajador(resp.data[0].id, { disponibilidad: "Bloqueado" })
                                .then(up => {
                                    console.log(up);
                                    setLoading(false);
                                    enqueueSnackbar("Trabajador bloqueado exitosamente !!", { variant: "success" });
                                }).catch(err => {
                                    console.log(err);
                                    setLoading(false);
                                    enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                                });
                        } else {
                            //Si no existe, lo creamos y bloqueamos
                            personaService.getPorRut(rut)
                                .then(pers => {
                                    var p = pers.data[0];
                                    console.log(p);
                                    setLoading(false);
                                    reclutamientoService.create({ rut: rut, nombre: p.perNombre1, ap_paterno: p.perApPaterno, disponibilidad: "Bloqueado" })
                                        .then(resp => {
                                            console.log(resp);
                                            setLoading(false);
                                            enqueueSnackbar("Trabajador bloqueado exitosamente !!", { variant: "success" });
                                        }).catch(err => {
                                            console.error(err);
                                            setLoading(false);
                                            enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                                        });
                                }).catch(err => {
                                    console.error(err);
                                    setLoading(false);
                                    enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                                });
                        }
                    }).catch(err => {
                        console.error(err);
                        setLoading(false);
                        enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                    });

                let up_p = await personaService.update(p.data[0].id, { estado_bloqueo: "Bloqueado" });
                setLoading(false); */
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
                enqueueSnackbar("Se cancelo la acción de bloquear", { variant: "info" });
            });
    }

    const bloquearMotivo = async () => {
        setLoading(true);
        let p = await personaService.getPorRut(rut);
        console.log("Bloquer a usuario");
        reclutamientoService.getUsuarioPorRut(rut)
            .then(resp => {
                if (resp.data.length !== 0) {
                    //Si existe la persona, actualizamos el estado a bloqueado
                    console.log(resp);
                    reclutamientoService.updateTrabajador(resp.data[0].id, { disponibilidad: "Bloqueado" })
                        .then(up => {
                            console.log(up);
                            setLoading(false);
                            enqueueSnackbar("Trabajador bloqueado exitosamente !!", { variant: "success" });
                            retreiveCasuales();
                        }).catch(err => {
                            console.log(err);
                            setLoading(false);
                            enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                        });
                } else {
                    //Si no existe, lo creamos y bloqueamos
                    personaService.getPorRut(rut)
                        .then(pers => {
                            var p = pers.data[0];
                            console.log(p);
                            setLoading(false);
                            reclutamientoService.create({ rut: rut, nombre: p.perNombre1, ap_paterno: p.perApPaterno, disponibilidad: "Bloqueado" })
                                .then(resp => {
                                    console.log(resp);
                                    setLoading(false);
                                    enqueueSnackbar("Trabajador bloqueado exitosamente !!", { variant: "success" });
                                    retreiveCasuales();
                                }).catch(err => {
                                    console.error(err);
                                    setLoading(false);
                                    enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                                });
                        }).catch(err => {
                            console.error(err);
                            setLoading(false);
                            enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                        });
                }
            }).catch(err => {
                console.error(err);
                setLoading(false);
                enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
            });

        let up_p = await personaService.update(p.data[0].id, { estado_bloqueo: "Bloqueado", motivo_bloqueo: motivobloqueo });
        setOpen(false);
        setLoading(false);
    }

    const columns = [
        { field: 'nombre', headerName: 'Nombre', width: 200 },
        { field: 'descripcion', headerName: 'Descripción', flex: 1 }
    ];

    //MUI Table

    const options = {
        filterType: 'multiselect',
        onRowSelectionChange: (rowsSelectedData, allRows, rowsSelected) => {
            SetArrSel(rowsSelected);
            //console.log(rowsSelectedData, allRows, rowsSelected);
        },
    };

    const columns2 = [
        { name: 'nombre', label: 'Nombre' },
        { name: 'descripcion', label: 'Causal' },
        { name: 'evaluacion', label: 'Evaluación' },
        { name: 'estado_desv', label: 'Estado Desvinculación' },
        { name: 'estado_bloqueo', label: 'Estado Bloqueo' },
        { name: 'motivo_bloqueo', label: 'Motivo Bloqueo' },
        { name: 'unidad', label: 'Unidad' },
        { name: 'cargo', label: 'Cargo' },
        { name: 'fecha_ingreso', label: 'Fecha Ingreso' },
        {
            name: 'rut', label: 'Editar', options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <Button variant='contained' onClick={() => bloquear(value)}>Bloquear</Button>
                )
            }
        }
    ];

    const bloqueMasivo = () => {
        for (var i in arr_sel) {
            var c = casuales[arr_sel[i]];
            console.log(c);
        }
    }

    return (
        loading ? (
            <div>
                <div className="d-flex justify-content-center">
                    <Oval
                        heigth="100"
                        width="100"
                        color='blue'
                        ariaLabel='loading'
                    />
                </div>
                <p className="text-center">Cargando ...</p>
            </div>
        ) : (
            <Container maxWidth="xl">
                <Box style={{
                    margin: 3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%'
                }}>
                    <Typography variant="h6" m={2}>
                        Trabajadores
                    </Typography>
                    <MUIDataTable
                        title={"Lista de Desvinculados"}
                        data={casuales}
                        columns={columns2}
                        options={options}
                    />
                    <Button onClick={() => bloqueMasivo()}>Bloqueo Masivo</Button>
                    <Divider></Divider>
                    {/* <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nombre</TableCell>
                                    <TableCell>Causal</TableCell>
                                    <TableCell>Evaluación</TableCell>
                                    <TableCell>Editar</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {casuales.map((item) => {
                                    return (
                                        <TableRow
                                            key={item.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {item.nombre}
                                            </TableCell>
                                            <TableCell align="left">{item.descripcion}</TableCell>
                                            <TableCell align="left">{item.evaluacion}</TableCell>
                                            <TableCell align="left"><Button variant="contained" onClick={() => bloquear(item.rut)}>Bloquear</Button></TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer> */}
                </Box>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    <Box sx={{ ...style, width: 400 }}>
                        <h2 id="parent-modal-title">Motivo del Bloqueo</h2>
                        <TextField
                            label="Motivo del bloqueo"
                            name="motivo_bloqueo"
                            id="motivo_bloqueo"
                            fullWidth
                            multiline
                            rows={4}
                            onChange={(e) => setMotivoBloqueo(e.target.value)}
                        />
                        <Box sx={{alignItems: "end", justifyContent: "end", display: "flex", margin: 2}}>
                            <Button variant="contained" onClick={bloquearMotivo}>Bloquear</Button>
                        </Box>
                    </Box>
                </Modal>
            </Container>
        )
    )
}

export default function AdminStack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <Admin />
        </SnackbarProvider>
    );
}